/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schukotel1Inputs */

const de__field_schukotel1 = /** @type {(inputs: _Field_Schukotel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SchuKo Telefonnummer`)
};

/**

* @param {_Field_Schukotel1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schukotel1 = /** @type {((inputs?: _Field_Schukotel1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schukotel1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schukotel1(inputs)
});
export { _field_schukotel1 as "_field_schukoTel" }